/**
 * MetaAccountFilter — seletor de contas Meta do cliente selecionado.
 *
 * Reaproveita o AccountFilter da tela de campanhas. Só aparece quando o cliente
 * tem mais de uma conta; a escolha fica no AppContext e zera ao trocar de cliente.
 */

import { useEffect, useMemo } from 'react'
import AccountSelect from './AccountSelect.jsx'
import { useApp } from '../context/AppContext.jsx'
import { getMetaAdsAccounts } from '../db/api.js'
import { useApiData } from '../hooks/useApiData.js'

// Mantém só ids que ainda existem entre as contas do cliente (sem filtro órfão).
export function sanitizeAccountIds(selected, accounts) {
  const valid = new Set((accounts || []).map((a) => String(a.id)))
  return (selected || []).filter((id) => valid.has(String(id)))
}

export function useMetaAccountFilter() {
  const { activeClient, metaAccountIds, setMetaAccountIds } = useApp()
  const { data } = useApiData(() => getMetaAdsAccounts(), [], { initialData: [], skip: !activeClient })
  const accounts = useMemo(
    () => (Array.isArray(data) ? data.map((a) => ({ id: a.id, name: a.name || a.id })) : []),
    [data]
  )
  const accountIds = useMemo(() => sanitizeAccountIds(metaAccountIds, accounts), [metaAccountIds, accounts])

  useEffect(() => {
    if (accounts.length && accountIds.length !== metaAccountIds.length) setMetaAccountIds(accountIds)
  }, [accounts, accountIds, metaAccountIds, setMetaAccountIds])

  // Com uma conta só o filtro não faz sentido: nada vai na query.
  const filterIds = accounts.length > 1 ? accountIds : []
  return { accounts, accountIds: filterIds, setAccountIds: setMetaAccountIds }
}

export default AccountSelect
